// extracted by mini-css-extract-plugin
export default {"grid__products":"categorydetail_grid__products__KXrgh","grid__product":"categorydetail_grid__product__CxAQX","grid__products_loader":"categorydetail_grid__products_loader__hBnF-"};